export const selectHardwareProps = (state) => state.assets.hardwareProps;
export const selectSimProps = (state) => state.assets.simProps;
export const selectAllHardware = (state) => state.assets.hardware;
export const selectAllSimcards = (state) => state.assets.simcards;
export const selectAssetDetails = (state) => state.assets.details;
